const customRequestCreatedMessage = "Your talent hunt request was successfully submitted";
const customRequestUpdatedMessage = "Your talent hunt request was successfully updated";

export {
  customRequestCreatedMessage,
  customRequestUpdatedMessage,
};